import { createStyles, makeStyles, Theme } from '@material-ui/core';

const ITEM_HEIGHT = 16.5;
const MIN_VISIBLE_ITEMS = 10.5;
const ITEM_PADDING_TOP = 8;

export const useCustomMultipleSelect = makeStyles(
  (theme: Theme) =>
    createStyles({
      input: {
        cursor: 'pointer',
      },
      root: {
        color: 'black',
      },
      '@keyframes inputLoading': {
        '0%': {
          transform: 'scaleX(0)',
          transformOrigin: 'left center',
        },
        '50%': {
          transform: 'scaleX(1)',
          transformOrigin: 'left center',
        },
        '51%': {
          transform: 'scaleX(1)',
          transformOrigin: 'right center',
        },
        '100%': {
          transform: 'scaleX(0)',
          transformOrigin: 'right center',
        },
      },
      loading: {
        overflow: 'hidden',
        '&::after': {
          animation: '$inputLoading 2s ease infinite',
        },
      },

      adornment: {
        flexFlow: 'nowrap',
      },
      adornmentButton: {
        padding: 0,
        fontSize: 23,
        color: '#828a82',
        '&:first-of-type:not(:last-of-type)': {
          fontSize: 12,
          marginRight: 4,
        },
        '& .MuiIconButton-label': {
          padding: '6px',
        },
      },
      adornmentIcon: {
        transition: 'transform 200ms ease',
        transform: 'rotate(0)',
        pointerEvents: 'none',
      },
      adornmentIconRotate: {
        transform: 'rotate(180deg)',
      },
      menu: {
        maxHeight: ITEM_HEIGHT * MIN_VISIBLE_ITEMS + ITEM_PADDING_TOP,
        '@media (min-width:300px) and (max-width:1100px)': {
          maxHeight: '140px',
        },
        borderRadius: 8,
        backgroundColor: '#fefefe',
        '&::-webkit-scrollbar': {
          width: 12,
          height: 12,
        },
        '&::-webkit-scrollbar-button': {
          display: 'none',
        },
        '&::-webkit-scrollbar-thumb': {
          transition: 'all .3s ease',
          borderRadius: 10,
          backgroundColor: '#cdd3cd',
          border: '3px solid #f8f9f7',
        },
      },
      menuItem: {
        minHeight: ITEM_HEIGHT,
        whiteSpace: 'normal',
      },
      menuItemCheckbox: {
        minWidth: 'unset',
        marginRight: theme.spacing(1),
      },
      menuItemFilter: {
        position: 'sticky',
        top: 0,
        left: 0,
        backgroundColor: '#fefefe',
        zIndex: 2,
      },
      menuItemActions: {
        position: 'sticky',
        bottom: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'flex-start',
        backgroundColor: '#fefefe',
        padding: '5px',
        zIndex: 2,
      },
      btnTextSelectedAll: {
        textAlign: 'start',
        lineHeight: '1.07rem',
        fontSize: '80%',
      },
      btnTextRemoveAll: {
        textAlign: 'start',
        lineHeight: '1.07rem',
        fontSize: '80%',
      },
    }),
  { name: 'CustomMultipleSelect' }
);
